import { render, staticRenderFns } from "./setting-question.vue?vue&type=template&id=054dc744&scoped=true&"
import script from "./setting-question.vue?vue&type=script&lang=js&"
export * from "./setting-question.vue?vue&type=script&lang=js&"
import style0 from "./setting-question.vue?vue&type=style&index=0&id=054dc744&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "054dc744",
  null
  
)

export default component.exports